import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { FormPublicDesignFragment } from '@/graphql/fragment/form.public.fragment';

interface SubmitModalProps {
  design: FormPublicDesignFragment;
}

const SubmitModal: FC<SubmitModalProps> = ({ design }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 120,
          height: 120,
          backgroundColor: design.colors.background,
          border: `2px solid ${design.colors.question}`,
          borderRadius: '8px',
          boxShadow: 24,
          padding: ['5%', 4],
        }}
      >
        <CircularProgress sx={{ color: design.colors.button }} />
      </Box>
    </Box>
  );
};

export default SubmitModal;
